import LogCannon from '@ace-clublabs/log-cannon';
import axios from 'axios';
import CookieHelper from '../../utils/cookieHelper';
import { GetCardTokenStatus, IGetCardTokenStatusResponse } from '../contracts';
import { createAxiosConfig } from '../mockHelper';
import { ErrorCode } from '@ace-clublabs/payment-types';
import { ErrorSeverity } from '../../shared/types';

export const GetCardTokenStatusApi = (endpoint: string): GetCardTokenStatus => {
  let logInfo: any = { endpoint };
  return async (token: string) => {
    try {
      LogCannon.blast('GetCardTokenStatusApi start', logInfo);
      const scenario = CookieHelper.getCookie('scenario');
      const config = createAxiosConfig(scenario, endpoint);
      const url = endpoint.replace('{clientToken}', token);

      const { data } = await axios.get(url, config);

      logInfo = { ...logInfo, data };
      LogCannon.blast('GetCardTokenStatusApi success', logInfo);

      if (data?.error?.code === ErrorCode.PrepaidCardNotAllowed) {
        return Promise.reject({
          code: ErrorCode.PrepaidCardNotAllowed,
          type: ErrorSeverity.SOFT,
        });
      }
      return Promise.resolve(data);
    } catch (error: any) {
      const message = (error?.response?.data?.error?.message || error?.response?.data?.error?.code) ?? 'An exception';
      logInfo = { ...logInfo, message };
      LogCannon.blast('GetCardTokenStatusApi failure', logInfo);
      return Promise.resolve({ status: message }) as unknown as IGetCardTokenStatusResponse;
    }
  };
};
